// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"cac2d085","484":"1bef058b","551":"2a37cce4","828":"89358f49","851":"ec3ecaab"}[chunkId] + ".chunk.js";
};